import {
  useMutation,
  useQuery,
  type UseMutationResult,
  type UseQueryResult,
} from "@tanstack/react-query";
import {
  getInjunctionDecisionPdfBlobByInjunctionId,
  openInjunctionDecisionDownloadByInjunctionId,
} from "@/api/cle-api";

export interface UseInjunctionDecisionByInjunctionIdParams {
  userId?: string;
  injunctionId?: string;
}

export const injunctionDecisionPdfQueryKey = ({
  userId,
  injunctionId,
}: UseInjunctionDecisionByInjunctionIdParams) =>
  [
    "cle-api",
    "users",
    userId,
    "pdf",
    "injunction-decisions",
    "by-injunction",
    injunctionId,
  ] as const;

export interface DownloadInjunctionDecisionParams {
  userId: string;
  injunctionId: string;
}

export const useDownloadInjunctionDecision = (): UseMutationResult<
  void,
  Error,
  DownloadInjunctionDecisionParams
> =>
  useMutation({
    mutationFn: openInjunctionDecisionDownloadByInjunctionId,
  });

export const useInjunctionDecisionPdf = ({
  userId,
  injunctionId,
}: UseInjunctionDecisionByInjunctionIdParams): UseQueryResult<Blob, Error> =>
  useQuery({
    queryKey: injunctionDecisionPdfQueryKey({ userId, injunctionId }),
    queryFn: () =>
      getInjunctionDecisionPdfBlobByInjunctionId({
        userId: userId ?? "",
        injunctionId: injunctionId ?? "",
      }),
    enabled: !!userId && !!injunctionId,
  });
